module.exports = __webpack_public_path__ + "img/sign-success-status.e7133947.png";